import { Form } from "antd";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { TimePicker } from "../index";

export const TimePickerField: FieldMethod = ({ field, readOnly, rules }: FormFieldFactoryProps) => {
    return (
        <Form.Item key={`${field.name}FormItem`} name={field.name} rules={rules}>
            <TimePicker key={field.name} name={field.name} label={field.translationKeys.label} readOnly={readOnly} />
        </Form.Item>
    );
};
